<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card" v-loading="loadingSync">
                <div class="card-header">
                    <h3 class="card-title w-100">
                        <div class="float-right">
                            Restant : <div class="badge badge-default">{{ countToSync }}</div>
                        </div>
                        Produits non synchronisés
                    </h3>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label for="nb">Nombre de produits à synchroniser</label>
                            <el-select
                                v-model="formSyncNoExists.limit"
                                filterable
                                allow-create
                                default-first-option
                                placeholder="Choisissez le nombre à envoyé">
                                <el-option
                                    v-for="item in optionNbToSync"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-md-2">
                            <label>&ensp;</label>
                            <el-button @click="sendSync" class="btn-inline-block" type="primary" plain>Envoyer</el-button>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <el-table
                                :data="listSync"
                                style="width: 100%">
                                <el-table-column
                                    prop="id"
                                    label="ID"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="sync_id"
                                    label="Sync ID">
                                </el-table-column>
                                <el-table-column
                                    prop="count"
                                    label="Nombre de ref">
                                </el-table-column>
                                <el-table-column
                                    prop="type"
                                    label="Type">
                                </el-table-column>
                                <el-table-column
                                    prop="action"
                                    label="Action">
                                </el-table-column>
                                <el-table-column
                                    prop="status"
                                    label="Status">
                                </el-table-column>

                                <el-table-column
                                    prop="created_at"
                                    label="Date de création">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Dashboard",
    data() {
        return {
            countToSync: 0,
            loadingSync: false,
            listSync: [],
            formSyncNoExists: {
                limit: 10000,
            },
            optionNbToSync: [
                {
                    value: 10000,
                    label: '10 000'
                },
                {
                    value: 5000,
                    label: '5 000'
                },
                {
                    value: 2000,
                    label: '2 000'
                },
                {
                    value: 1000,
                    label: '1 000'
                },
                {
                    value: 500,
                    label: '500'
                },
            ]
        }
    },
    async mounted() {
        this.loadingSync = true;
        await this.getSync();
        this.loadingSync = false;
    },
    methods: {
        async getSync() {
            let response = await axios.get('/comarch/listSync');
            this.listSync = response.data.crapiSyncList;
            this.countToSync = response.data.countToSync;
        },
        async sendSync() {
            this.loadingSync = true;
            let response = await axios.post('/comarch/sendSync', this.formSyncNoExists);
            this.loadingSync = false;
            this.$message({
                message: response.data.message,
                type: response.data.status ? 'success' : 'error'
            });
        }
    }
}
</script>

<style scoped>
    .btn-inline-block {
        display: inline-block;
        width: 100%;
    }
</style>
